<ng-container *transloco="let t">
    <vds-header class="px-8! sm:px-24!">
        <ng-container ngProjectAs="vds-header-menu">
            <div class="flex items-center gap-x-8">
                <button
                    [attr.aria-label]="t('mainNavigation')"
                    vds-icon-button
                    appearance="ghost"
                    mode="dark"
                    (click)="toggleAppDrawer.emit()"
                >
                    <vds-icon name="menu" />
                </button>
            </div>
        </ng-container>
        <ng-container ngProjectAs="[vds-header-logo]">
            <a class="rounded-xs px-4 focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-hidden" routerLink="jumpboard">
                <vo-logo />
            </a>
            <span class="mr-4 h-[18px] w-px border-l border-gray-600"></span>
            <span class="text-14 font-semibold">{{ t(title()) }}</span>
        </ng-container>
        <div class="flex items-center gap-x-4" vds-header-actions>
            <vo-update-prompt-button />

            @if (isHandset()) {
                @if (user(); as user) {
                    <vo-shell-user-menu
                        [user]="user"
                        [triggerLabel]="t('userMenu')"
                        (toggleDrawer)="toggleFeatureFlagsDrawer()"
                        (logout)="logout()"
                    />
                }
            } @else {
                <a
                    *applicationAllowed="applicationIds.CaseManagement"
                    vds-icon-button
                    appearance="ghost"
                    mode="dark"
                    routerLink="support/create-case"
                    ampRouterEvent
                    ampEventContext="Support - header link"
                    [vdsTooltip]="t('cmRequestSupportTitle')"
                    placement="bottom"
                >
                    <vds-icon name="help" />
                </a>

                <vo-notifications-header-area />
                @if (user(); as user) {
                    <vo-shell-user-menu
                        [user]="user"
                        [triggerLabel]="t('userMenu')"
                        (toggleDrawer)="toggleFeatureFlagsDrawer()"
                        (logout)="logout()"
                    />
                    <shell-ui-language-menu
                        [language]="user.language"
                        [triggerLabel]="t('languages')"
                        (languageChange)="setUserLocale($event, user)"
                    />
                }
            }
        </div>
    </vds-header>
    <dcc-feature-flags-sidebar [open]="showFeatureFlags()" (close)="showFeatureFlags.set(false)" />
</ng-container>
